import { Component } from "@angular/core";
import { NavigationError, Router } from "@angular/router";
import { AuthService } from "./services/auth/auth.service";

/** Marca en sessionStorage para recargar una sola vez por pantalla y no entrar en bucle. */
const STALE_RELOAD_KEY = "stale_chunk_reload";

/**
 * Raíz de la app: solo el aviso de conexión y el router.
 *
 * Antes arrancaba en cada carga, para todos los roles, tres escuchas
 * heredadas del backoffice de delivery: todas las órdenes pendientes del
 * país del día (con sonido y toast), las conversaciones de chat en Realtime
 * Database y las solicitudes de cuentas de negocio. Nada de eso es de
 * eventos y cada una costaba lecturas, memoria y una conexión abierta
 * desde antes de mostrar la primera pantalla.
 */
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  constructor(public auth: AuthService, private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationError) this.recoverFromStaleBundle(event);
    });
  }

  logout() {
    this.auth.logOut();
  }

  /**
   * Cada pantalla se descarga aparte (chunk) cuando se entra a ella. Si la
   * pestaña lleva abierta desde antes de una publicación o de una
   * recompilación del servidor de desarrollo, el `main` viejo pide un chunk
   * que ya no encaja con él y la carga falla con "Loading chunk … failed" o
   * "Cannot read properties of undefined (reading 'call')". La única salida
   * es traer la versión nueva completa: se recarga la página una vez y se
   * vuelve a la misma ruta. Si la recarga no lo arregla, no se insiste.
   */
  private recoverFromStaleBundle(event: NavigationError) {
    const message = String((event.error && (event.error.message || event.error)) || "");
    const stale = /Loading chunk|ChunkLoadError|reading 'call'|Cannot find module/i.test(message);
    if (!stale) return;
    // Misma ruta fallando otra vez en menos de medio minuto: ya se recargó y no sirvió.
    let last = "";
    try {
      last = sessionStorage.getItem(STALE_RELOAD_KEY) || "";
    } catch (e) { /* sin sessionStorage: se recarga igual */ }
    const [lastUrl, lastAt] = last.split("|");
    if (lastUrl === event.url && Date.now() - Number(lastAt || 0) < 30000) {
      console.error("La pantalla no cargó ni después de recargar:", message);
      return;
    }
    try {
      sessionStorage.setItem(STALE_RELOAD_KEY, `${event.url}|${Date.now()}`);
    } catch (e) { /* nada */ }
    console.warn("Versión desactualizada de la app en esta pestaña; se recarga para traer la nueva.", message);
    window.location.href = `${window.location.pathname}#${event.url}`;
    window.location.reload();
  }
}
